import { ColumnDef } from '@tanstack/react-table';

import { Approval } from '@/app/org-cfv/src/typings/ActivityDataDetailsTypings';
import { EmissionsType } from '@/app/org-cfv/src/typings/CreateActivityDataTypings';
import { NextTFunction } from '@/i18n/client';

// This file contains the columns for cat3.1 / cat4.1

export const getEmissionSourceTypeHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview ? 'metadata.emissionSourceType' : 'activityData.metadata.emissionSourceType';
  return {
    header: t('common.emission'),
    accessorKey,
    cell: ({ getValue }) => {
      const val = getValue();
      return val ? t(`fd-raw-material.emission-${val as string}`) : '';
    },
  };
};

export const getPartNoHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview ? 'metadata.partNo' : 'activityData.metadata.partNo';
  return {
    header: t('fd-raw-material.companyPartNo'),
    accessorKey,
  };
};

export const getVendorCodeHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview ? 'metadata.vendorCode' : 'activityData.metadata.vendorCode';
  return {
    header: t('fd-raw-material.vendorCode'),
    accessorKey,
  };
};

export const getShipmentLocationCodeHeader = (
  t: NextTFunction,
  isBulkPreview: boolean = false,
): ColumnDef<Approval & EmissionsType> => {
  const accessorKey = isBulkPreview ? 'metadata.shipmentLocationCode' : 'activityData.metadata.shipmentLocationCode';
  return {
    header: t('fd-raw-material.shipmentLocationCode'),
    accessorKey,
  };
};
